import { render, staticRenderFns } from "./VariantRulesDetail.vue?vue&type=template&id=57dcd481&lang=pug&"
import script from "./VariantRulesDetail.vue?vue&type=script&lang=ts&"
export * from "./VariantRulesDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports